import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RequestError } from '../../../interfaces/error.interface';
import { Secuence } from '../../../interfaces/secuence.interface';
import { GetSecuencesParams, GetSecuencesResponse } from '../interfaces/get-secuences';

export interface EmailsState {
  secuences: Secuence[];
  secuence: Secuence | null;
  options: GetSecuencesParams;
  errorCode: number | null;
}

const initialState: EmailsState = {
  secuences: [],
  options: { text: '' },
  secuence: null,
  errorCode: null,
};

const emailSlice = createSlice({
  name: 'email',
  initialState,
  reducers: {
    getSecuencesInitApiAction: (state) => {
      state.errorCode = null;
    },
    getSecuencesSuccessApiAction: (state, action: PayloadAction<GetSecuencesResponse>) => {
      state.secuences = action.payload.secuences;
    },
    getSecuencesFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    postSecuenceInitApiAction: () => {},
    postSecuenceSuccessApiAction: () => {},
    postSecuenceFailuireApiAction: () => {},
    putSecuenceInitApiAction: () => {},
    putSecuenceSuccessApiAction: () => {},
    putSecuenceFailuireApiAction: () => {},
    deleteSecuenceInitApiAction: () => {},
    deleteSecuenceSuccessApiAction: () => {},
    deleteSecuenceFailuireApiAction: () => {},
    setSecuenceAction: (state, action: PayloadAction<Secuence>) => {
      state.secuence = action.payload;
    },
    setOptionsAction: (state, action: PayloadAction<GetSecuencesParams>) => {
      state.options = action.payload;
    },
    resetOptionsAction: (state) => {
      state.options = { text: '' };
    },
    emailClearAction: (state) => {
      state.secuences = [];
      state.secuence = null;
    },
  },
});

export const {
  getSecuencesInitApiAction,
  getSecuencesSuccessApiAction,
  getSecuencesFailureApiAction,
  postSecuenceInitApiAction,
  postSecuenceSuccessApiAction,
  postSecuenceFailuireApiAction,
  putSecuenceInitApiAction,
  putSecuenceSuccessApiAction,
  putSecuenceFailuireApiAction,
  deleteSecuenceInitApiAction,
  deleteSecuenceSuccessApiAction,
  deleteSecuenceFailuireApiAction,
  setSecuenceAction,
  setOptionsAction,
  resetOptionsAction,
  emailClearAction,
} = emailSlice.actions;

export default emailSlice.reducer;
